import {
  DatasourceUpgradeFieldSpecDiff,
  DatasourceUpgradeItemDiff,
  DatasourceUpgradePreserveUnreferencedColumnsDiff,
  DatasourceUpgradeStringFieldDiff,
  DatasourceUpgradeStringFieldsDiff,
  DatasourceUpgradeTableDiff,
} from '../datasourceUpgrade.types';

export const isTableChange = (
  change: DatasourceUpgradeTableDiff | DatasourceUpgradeItemDiff,
): change is DatasourceUpgradeTableDiff => {
  return change.type === 'table';
};

export const isFieldSpecChange = (
  change: DatasourceUpgradeTableDiff | DatasourceUpgradeItemDiff,
): change is DatasourceUpgradeFieldSpecDiff => {
  return change.type === 'fieldSpec';
};

export const isStringFieldChange = (
  change: DatasourceUpgradeTableDiff | DatasourceUpgradeItemDiff,
): change is DatasourceUpgradeStringFieldDiff => {
  return change.type === 'string';
};

export const isMultiValueFieldChange = (
  change: DatasourceUpgradeTableDiff | DatasourceUpgradeItemDiff,
): change is DatasourceUpgradeStringFieldsDiff => {
  return change.type === 'strings';
};

export const isPreserveUnreferencedColumnsChange = (
  change: DatasourceUpgradeTableDiff | DatasourceUpgradeItemDiff,
): change is DatasourceUpgradePreserveUnreferencedColumnsDiff => {
  return change.type === 'preserveUnreferencedColumns';
};

export const getUpgradeChangeKey = (
  change: DatasourceUpgradeTableDiff | DatasourceUpgradeItemDiff,
) => {
  if (isTableChange(change)) {
    return `upgrade-table-change-${change.tableName}`;
  }

  return `upgrade-field-spec-change-${change.title}`;
};
